import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import AppShell from "./AppShell";
import HomePage from "./HomePage";
import ScanPage from "./ScanPage";
import ScanSortiePage from "./ScanSortiePage";
import InventairePage from "./InventairePage";
import InventairesListPage from "./InventairesListPage";
import InventaireDetailsPage from "./InventaireDetailsPage";

function App() {
  return (
    <BrowserRouter>
      {/* AppShell est à l'intérieur du router : la nav basse utilise useNavigate. */}
      <AppShell>
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route path="/scan-entree" element={<ScanPage />} />
          <Route path="/scan-sortie" element={<ScanSortiePage />} />

          <Route path="/inventaire" element={<InventairePage />} />
          <Route path="/inventaire/:id" element={<InventairePage />} />
          <Route path="/inventaires" element={<InventairesListPage />} />
          <Route path="/inventaires/:id" element={<InventaireDetailsPage />} />
        </Routes>
      </AppShell>
    </BrowserRouter>
  );
}

export default App;
